export default [
    /*** 查排名  数据查询 ***/
    {
        path: '/rank/dataquery',
        component: () => import('../pages/rank/dataQuery/index.vue'),
        meta: { title: ' 数据查询' }
    },
    /*** 查排名  学院详情 ***/
    {
        path: '/rank/academy/:collegeCode',
        component: () => import('../pages/rank/dataQuery/academy.vue'),
        meta: { title: ' 学院详情' }
    },
    /*** 查排名  专业详情 ***/
    {
        path: '/rank/major/:collegeCode',
        component: () => import('../pages/rank/dataQuery/major.vue'),
        meta: { title: ' ' }
    },
    /*** 查排名  学员列表 ***/
    {
        path: '/rank/userlist',
        component: () => import('../pages/rank/userList/index.vue'),
        meta: { title: ' 学员列表' }
    },
    /*** 查排名  门类列表 ***/
    {
        path: '/rank/category',
        component: () => import('../pages/rank/category/index.vue'),
        meta: { title: ' 门类列表' }
    },
    /*** 查排名  二级门类  学科详情 ***/
    {
        path: '/rank/category/leveltwo',
        component: () => import('../pages/rank/category/level_two.vue'),
        meta: { title: ' 门类列表' }
    },
    /*** 查排名  三级门类  专业详情 ***/
    {
        path: '/rank/category/levelthree',
        component: () => import('../pages/rank/category/level_three.vue'),
        meta: { title: ' 门类列表' }
    },
    /*** 查排名  成绩审核 ***/
    {
        path: '/rank/question',
        component: () => import('../pages/rank/question/index.vue'),
        meta: { title: ' 成绩审核' }
    },
]